export default __webpack_public_path__ + "static/media/RecordedIcon.dc4f70c2.svg";